import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormService } from 'app/services/form.service';

@Component({
  selector: 'app-degree-of-polymerization',
  templateUrl: './degree-of-polymerization.component.html',
  styleUrls: ['./degree-of-polymerization.component.scss']
})
export class DegreeOfPolymerizationComponent implements OnInit {
  @ViewChild('degreeOfPolymerizationDisclosureInput') degreeOfPolymerizationDisclosureInput!: ElementRef;
  degreeOfPolymerizationDisclosure!: string;

  constructor(private formService: FormService) {}
  
  ngOnInit(): void {
    this.degreeOfPolymerizationDisclosure = this.currentForm.get('degreeOfPolymerizationDisclosure')?.value;
  }

  public clearDegreeOfPolymerizationDisclosureInputField() {
    this.degreeOfPolymerizationDisclosure = '';
    this.currentForm.patchValue({'degreeOfPolymerizationDisclosure': ''});
  }

  public updateDegreeOfPolymerizationDisclosure(event: Event) {
    if(event && event.type === 'blur') {
      var target = document.activeElement;
      if(target && target.nodeValue === "cancel") {
        this.degreeOfPolymerizationDisclosure = '';
      }
    }
    this.currentForm.patchValue({'degreeOfPolymerizationDisclosure': this.degreeOfPolymerizationDisclosure});
  }

  public cancelUpdate() {
    this.degreeOfPolymerizationDisclosure = this.currentForm.get('degreeOfPolymerizationDisclosure')?.value;
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }

}
